module.exports = __webpack_public_path__ + "static/media/natural-stone.cc3e5013.svg";